import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-p20" }
const _hoisted_2 = { class: "-page-tip -main" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "-title",
  style: {"font-size":"1.1em"}
}, "接入信息", -1)
const _hoisted_4 = { class: "-content" }
const _hoisted_5 = { style: {"line-height":"2.4em"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { style: {"width":"80px","text-align":"right"} }, "商户名称：", -1)
const _hoisted_7 = { style: {"line-height":"2.4em"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { style: {"width":"80px","text-align":"right"} }, "AppId：", -1)
const _hoisted_9 = { style: {"line-height":"2.4em"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { style: {"width":"80px","text-align":"right"} }, "AppSecret：", -1)
const _hoisted_11 = { style: {"line-height":"2.4em"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { style: {"width":"80px","text-align":"right"} }, "接口文档：", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("dl", _hoisted_4, [
        _createElementVNode("dd", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(_toDisplayString($setup.setting.name), 1)
        ]),
        _createElementVNode("dd", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(_toDisplayString($setup.setting.AppId), 1)
        ]),
        _createElementVNode("dd", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(_toDisplayString($setup.setting.AppSecret), 1)
        ]),
        _createElementVNode("dd", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("i", {
            class: "-cmain",
            style: {"cursor":"pointer"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx._msg('请联系商务获取')))
          }, "接口文档")
        ])
      ])
    ])
  ]))
}